function EnemNotesPanel({ inscricao }) {
  const enemData =
    inscricao?.aproveitamentoNotasExternas ||
    inscricao?.aproveitamento_notas_externas;

  if (!enemData) return null;

  return (
    <>
      <h5 style={{ color: "black", marginTop: 10, marginBottom: 10 }}>
        Aproveitamento de Notas (ENEM)
      </h5>
      <div>
        <div style={{ marginBottom: 5 }}>
          <b style={{ color: "black" }}>Ano de Realização: </b>
          <span>{enemData.ano_realizacao || "-"}</span>
        </div>
        <div style={{ marginBottom: 10 }}>
          <b style={{ color: "black" }}>Número de Inscrição: </b>
          <span>{enemData.numero_inscricao || "-"}</span>
        </div>

        {enemData.notas &&
          Array.isArray(enemData.notas) &&
          enemData.notas.length > 0 && (
            <div>
              <b style={{ color: "black" }}>Notas por Área:</b>
              <ul style={{ paddingLeft: 18, marginTop: 5 }}>
                {enemData.notas.map((notaItem, idx) => (
                  <li key={`enem-nota-${idx}`} style={{ marginBottom: 4 }}>
                    <b>{notaItem.area}: </b>
                    <span>{notaItem.nota}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
      </div>
    </>
  );
}

export default EnemNotesPanel;
